export const initialState = () => ({
  document: "",
  type: "",
  rg: "",
  name: "",
  birthDate: "",
  motherName: "",
  fatherName: "",
  gender: "",
  schooled: "",
  maritalStatus: "",
  profession: "",
  professionName: "",

  companyName: "",
  companyType: "",
  openingDate: "",
  responsible: {
    name: "",
    cpf: ""
  },
  stateRegistration: "",
  contactName: "",

  email: "",
  cellphone: "",
  landline: "",
  anotherContact: "",
  note: ""
})
